<template>
  <v-container class="pt-0">
    <v-row>
      <v-col cols="10">
        <v-date-picker
          :allowed-dates="allowedDates"
          :min="today"
          full-width
          v-model="date"
        ></v-date-picker>
      </v-col>
      <v-col class="available-time-container">
        <available-time
          :first="!index"
          :key="item"
          :value="item"
          v-for="(item, index) in availableTimes"
        ></available-time>
        <v-skeleton-loader
          class="skeleton-loader"
          min-height="200"
          type="button@4"
          v-if="loading && !availableTimes.length"
        ></v-skeleton-loader>
        <v-card-text v-else-if="!availableTimes.length" class="pa-0 pr-2 text-center">
          There're no appointments for the selected date
        </v-card-text>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
.available-time-container {
  max-height: 400px;
  overflow-y: auto;
}

.skeleton-loader .v-skeleton-loader__button {
  height: 44px;
  margin-bottom: 0.5rem;
  width: 100%;
}
</style>
<script>
import moment from 'moment';

import { DATE_FORMAT } from '../constants/moment';
import AvailableTime from '../components/AvailableTime.vue';

export default {
  name: 'DateTime',
  components: { AvailableTime },
  data: () => ({
    today: moment().format(DATE_FORMAT),
    date: moment().format(DATE_FORMAT),
    loading: false,
  }),
  mounted() {
    const { date, time } = this.$store.state.appointment;
    this.date = date;

    this.$store.commit('updateAppointment', {
      title: 'Choose your preferred time',
      next: !!(date && time),
    });

    this.$store.watch(
      (state) => state.appointment.time,
      (value) => {
        this.$store.commit('updateAppointment', { next: !!value });
      }
    );

    this.searchTimesForDay(date);
  },
  watch: {
    date(value) {
      this.$store.commit('updateAppointment', { time: null });
      this.searchTimesForDay(value);
    },
  },
  methods: {
    allowedDates() {
      // @TODO Search month availability for each day
      return true;
    },
    searchTimesForDay(day) {
      if (!this.$store.state.availableTimes[day]) {
        this.loading = true;
        this.$store
          .dispatch('searchAvailableTimes', { day })
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
  computed: {
    availableTimes() {
      return this.$store.state.availableTimes[this.date] || [];
    },
  },
};
</script>
